import * as CAMPAIGN_CONST from 'Reducers/Campaigns/const'

/**
 * Will be a hashmap of metricResult records, id => value
 */
const defaultState = {}

export const metricResults = function(state = defaultState, action) {
  switch (action.type) {
    case CAMPAIGN_CONST.GET_CAMPAIGN_RESULTS_SUCCESS: {
      return {
        ...state,
        ...(() => {
          var metricResults = {}
          var cityPlans = action.result.data.campaign.cityPlans.nodes
          cityPlans.forEach(cityPlan => {
            cityPlan.missions.edges.forEach(({ node }) => {
              node.metricResults.nodes.forEach(result => {
                metricResults[result.id] = {
                  id: result.id,
                  value: result.value,
                  metricId: result.metric.id,
                }
              })
            })
          })
          return metricResults
        })(),
      }
    }
    default:
      return state
  }
}
